var map = {
	"./Media": "057b",
	"./Media.vue": "057b",
	"./Media_back": "c978",
	"./Media_back.vue": "c978",
	"./Projection": "c03e",
	"./Projection.vue": "c03e",
	"./Visitor": "4388",
	"./Visitor.vue": "4388",
	"./Visitor_AFRAME": "7155",
	"./Visitor_AFRAME.vue": "7155",
	"./Visitor_AR": "3f61",
	"./Visitor_AR.vue": "3f61",
	"./Visitor_ARwebm": "b132",
	"./Visitor_ARwebm.vue": "b132",
	"./Webm": "69d2",
	"./Webm.vue": "69d2",
	"./targets/cadre.png": "d81d",
	"./targets/f2.png": "8774",
	"./targets/outside.jpg": "ac19",
	"./targets/temp/cadre.png": "dfb1",
	"./targets/temp/f1.png": "07ce",
	"./targets/temp/f2.png": "d7b2",
	"./targets/temp/white.png": "11e0",
	"./targets/temp/yellow.png": "0c3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9d9d";